export default __webpack_public_path__ + "static/media/plans.886ca71d.svg";